import http from "../helpers/http-common"

class AuthService {

    updateEmail(userId, email) {
        const params = {};
        params['userId'] = userId;
        params['email'] = email;
        return http.post("/auth/updateEmail", params);
    }
    updatePassword(userId, password) {
        const params = {};
        params['userId'] = userId;
        params['passwd'] = password;
        return http.post("/auth/updatePasswd", params);
    }
    updatePhone(userId, phone) {
        const params = {};
        params['userId'] = userId;
        params['phone'] = phone;
        return http.post("/auth/updatePhone", params);
    }
    updatePhoto(userId, photo) {
        const params = {};
        params['userId'] = userId;
        params['photo'] = photo;
        return http.post("/auth/updatePhoto", params);
    }
    disableUser(userId, adminId) {
        const params = {};
        params['userId'] = userId;
        params['adminId'] = adminId;
        return http.post("/auth/disableUser", params);
    }
    enableUser(userId, adminId) {
        const params = {};
        params['userId'] = userId;
        params['adminId'] = adminId;
        return http.post("/auth/enableUser", params);
    }
    deleteUser(userId, adminId) {
        const params = {};
        params['userId'] = userId;
        params['adminId'] = adminId;
        return http.post("/auth/deleteUser", params);
    }

    checkUser(params) {
        return http.post("/unauth/checkUser", params);
    }

    verifyOTP(params) {
        return http.post("/unauth/verifyTOTP", params);
    }

    validateOTP(params) {
        return http.post("/unauth/validateTOTP", params);
    }
}

export default new AuthService();
